module.exports = {
  title: 'RuneScape Stats',
  description: `
    To anyone out there that enjoys Old School RuneScape (I know there has to be a few of you, right?) this one's for you.
    I went through a few nostalgia trips and decided to get back into RuneScape again with some coworkers and this was the result.
    We wanted to be able to compare our levels and see who was doing the best, and we got it.
  `,
  tags: ['Angular', 'CSS', 'Design', 'RuneScape API',],
  images: [require('./images/1.png'), require('./images/2.png'), require('./images/3.png'),],
  url: 'https://rs.christieman.com/',
};



// WEBPACK FOOTER //
// ./src/data/works/runescape/index.js